import { rules } from '@/utils/validationUtils';
import { createGetPropGetter } from '@/store/utils';

export default {
  invitationValidationSuccessful: createGetPropGetter('invitationValidationSuccessful', {}),
  isUserPoolExist: createGetPropGetter('isUserPoolExist', null),
  registrationCompanyInfo: createGetPropGetter('companyInfo', {}),
  registrationCurrentStep: createGetPropGetter('currentStep', 1),
  registrationVisitedStepsCnt: createGetPropGetter('visitedStepsCnt', 1),
  registrationFilledStepsCnt: createGetPropGetter('filledStepsCnt', 0),
  registrationRegions: createGetPropGetter('regions', []),
  registrationIndustries: createGetPropGetter('industries', []),
  registrationRegulations: createGetPropGetter('regulations', []),
  registrationAmountOfEmployees: createGetPropGetter('amountOfEmployees', []),
  registrationCybersecurityKnowhowOptions: createGetPropGetter('cybersecurityKnowhowOptions', []),
  registrationCompanySuggestions: createGetPropGetter('companySuggestions', []),
  registrationLoadingStatuses: createGetPropGetter('loading', {}),
  registrationLoadingErrors: createGetPropGetter('loadingErrors', {}),
  registrationClientInfo: createGetPropGetter('clientInfo', {}),
  registrationRecaptchaToken: createGetPropGetter('recaptchaToken'),
  invitationValidationRecaptchaToken: createGetPropGetter('invitationValidationRecaptchaToken'),
  emailVerificationSent: createGetPropGetter('emailVerificationSent'),
  registrationClientAvatar: createGetPropGetter('clientAvatar'),
  whiteLabeling: createGetPropGetter('whiteLabeling', null),
  registrationUserEmail: createGetPropGetter('registrationUserEmail'),
  companySuggestionsLoading: state => state.loading.companySuggestions,
  allowNextFirstStep: state => {
    const {
      companyInfo: {
        industry, regulation, officeLocation, employeesNumber, organizationName, organizationDomain,
      },
    } = state;

    return Boolean(
      regulation?.length > 0 &&
        industry?.value &&
        officeLocation?.id &&
        employeesNumber &&
        organizationName &&
        rules.domain(organizationDomain),
    );
  },
  allowNextSecondStep: (state, getters) => {
    const {
      recaptchaToken,
      clientInfo: {
        valid,
        password,
        lastName,
        jobTitle,
        firstName,
        workEmail,
        confirmPassword,
        cybersecurityKnowhow,
        companyTermsAccepted,
        privacyPolicyAccepted,
        termsAndConditionsAccepted,
      },
    } = state;

    return Boolean(
      valid &&
        getters.allowNextFirstStep &&
        recaptchaToken &&
        firstName &&
        lastName &&
        jobTitle &&
        workEmail &&
        cybersecurityKnowhow &&
        password &&
        confirmPassword &&
        password === confirmPassword &&
        privacyPolicyAccepted &&
        companyTermsAccepted &&
        termsAndConditionsAccepted,
    );
  },
};
